import styled from 'styled-components';

const StyledContainer = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.wait-enter {
		opacity: 0;
	}

	&.wait-enter-active,
	&.wait-enter-done,
	&.wait-exit {
		opacity: 1;
	}

	&.wait-exit-active {
		opacity: 0;
	}

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
	}
`;

export { StyledContainer };
